module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_17.ce3559ba.jpg";